(function () {
	function resolveDepartment(dept) {
		return dept === 'kids' ? 'women' : dept;
	}

	function currentDepartment() {
		var dept = window.activeDepartment || localStorage.getItem('activeDepartment') || 'women';
		return resolveDepartment(dept);
	}

	function applyTo(root, gender) {
		root.querySelectorAll('[data-gender]').forEach(function (panel) {
			if (panel.dataset.gender === gender) {
				panel.removeAttribute('hidden');
				panel.removeAttribute('inert');
				/* Cart-page panels host Swiper (.section-slider) instances initialized
				   in global.js. Swipers initialized while a panel was hidden have
				   stale (zero) dimensions; .update() recalculates after reveal.
				   `inert` covers focus + AT semantics for the inactive panel since
				   our CSS overrides [hidden]'s native display:none on the cart page
				   to keep both panels measurable for Swiper. */
				panel.querySelectorAll('.section-slider').forEach(function (slider) {
					if (slider.swiperInstance && typeof slider.swiperInstance.update === 'function') {
						slider.swiperInstance.update();
					}
				});
			} else {
				panel.setAttribute('hidden', '');
				panel.setAttribute('inert', '');
			}
		});
	}

	function applyAll(gender) {
		document.querySelectorAll('[data-cross-sell]').forEach(function (root) {
			applyTo(root, gender);
		});
	}

	function init() {
		applyAll(currentDepartment());
	}

	document.addEventListener('departmentChange', function (e) {
		var dept = (e.detail && e.detail.department) ? resolveDepartment(e.detail.department) : currentDepartment();
		applyAll(dept);
	});

	if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
		subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
			requestAnimationFrame(init);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
